import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { PersonalDetailsRequestAction, PersonalDetailsResponseAction } from './actions';
import { PersonalDetailsService } from 'src/app/services/personal-details.service';

@Injectable()
export class PersonalDetailsEffects {
  constructor(private actions$: Actions,
    private service: PersonalDetailsService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(PersonalDetailsRequestAction),
    switchMap((action: any) => {
      return this.service.getData(action.accountId).pipe(
      map((data: any) => {
        return PersonalDetailsResponseAction({ wording: data.data });
      }),
      catchError(_err => {
        return EMPTY;
      })
    )
    }),
  ));

}
